import React from "react";
import VerticalBlog from "../VerticalBlog";
import styles from "../../../styles/Blog/VerticalBlog.module.css";

export const MobileBlogs = ({ blogs }) => {
  return (
    <div className={styles.VerticalBlogContainer}>
      <div className={styles.VerticalBlogTitle}>Featured This Month</div>
      {blogs.length > 0 ? (
        blogs.map((blog, index) => <VerticalBlog key={index} data={blog} />)
      ) : (
        <p>No blogs available this month.</p>
      )}
    </div>
  );
};
